import {
    Avatar,
    Divider,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from "@material-ui/core";
import React from "react";
import styled from "styled-components";

interface GeneralInfoListItemProps {
    icon: any,
    title: string;
}

const IconView = styled(Avatar)`
  background-color: #046A38;
`;

const GeneralInfoListItem = (props: GeneralInfoListItemProps) => {
    const {icon, title} = props;

    return (
        <>
            <ListItem disableGutters>
                <ListItemAvatar>
                        <IconView>{icon}</IconView>
                </ListItemAvatar>
                <ListItemText primary={title || ""} />
            </ListItem>
            <Divider variant={'middle'} component={'li'} />
        </>
    );
};

export default GeneralInfoListItem;